class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.navigationTabs = this.querySelector(".product-tabs__tabs");
    this.tabsContent = this.querySelectorAll(".product-tabs__content");
    this.leftArrow = this.querySelector(".scroll-left");
    this.rightArrow = this.querySelector(".scroll-right");
    this.stickyEl = this.querySelector(".product-tabs__top-content");

    if (!this.navigationTabs || !this.tabsContent.length) {
      return;
    }

    this.isDragging = false;
    this.dragThreshold = 5;

    this.init();
    this.setupScrolling();
    this.setupDragging();
    this.checkForContactSubmission();
    this.observeStickyState();
  }

  init() {
    this.querySelectorAll(".product-tabs__tab").forEach((tab) => {
      tab.addEventListener("click", (event) => {
        if (this.isDragging) {
          event.preventDefault();
          return;
        }

        const index = tab.getAttribute("data-index");
        this.activateTab(index, false);
      });
    });
  }

  activateTab(index, shouldScroll = false) {
    this.querySelectorAll(".product-tabs__tab").forEach((tab) => tab.classList.remove("active"));
    this.querySelector(`.product-tabs__tab[data-index="${index}"]`).classList.add("active");

    this.tabsContent.forEach((tabContent) => {
      tabContent.classList.remove("active");
      if (tabContent.getAttribute("data-index") === index) {
        tabContent.classList.add("active");
      }
    });

    if (shouldScroll) {
      const targetContent = this.querySelector(`.product-tabs__content[data-index="${index}"]`);
      if (targetContent) {
        targetContent.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  checkForContactSubmission() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("contact_posted")) {
      const questionTab = this.querySelector(".product-tabs__tab[data-question-tab]");
      if (questionTab) {
        const index = questionTab.getAttribute("data-index");
        this.activateTab(index, true); 
        this.cleanUrl();
      }
    }
  }

  cleanUrl() {
    const newUrl = window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
  }

  setupScrolling() {
    if (!this.leftArrow || !this.rightArrow) return;

    const scrollAmount = 100;

    this.leftArrow.addEventListener("click", () => {
      this.navigationTabs.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setTimeout(() => this.updateArrows(), 300);
    });

    this.rightArrow.addEventListener("click", () => {
      this.navigationTabs.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setTimeout(() => this.updateArrows(), 300);
    });

    this.navigationTabs.addEventListener("scroll", () => this.updateArrows());
    window.addEventListener("resize", () => this.updateArrows());

    this.updateArrows();
  }

  setupDragging() {
    let startX;
    let scrollLeft;
    let movedDistance = 0;

    this.navigationTabs.addEventListener("mousedown", (e) => {
      this.isDragging = false;
      movedDistance = 0;

      startX = e.pageX - this.navigationTabs.offsetLeft;
      scrollLeft = this.navigationTabs.scrollLeft;

      this.navigationTabs.classList.add("dragging");

      const onMouseMove = (e) => {
        const x = e.pageX - this.navigationTabs.offsetLeft;
        movedDistance = Math.abs(x - startX);

        if (movedDistance > this.dragThreshold) {
          this.isDragging = true;
        }

        const walk = (x - startX) * 1;
        this.navigationTabs.scrollLeft = scrollLeft - walk;
      };

      const onMouseUp = () => {
        this.navigationTabs.classList.remove("dragging");

        setTimeout(() => {
          this.isDragging = movedDistance > this.dragThreshold;
        }, 50);

        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });

    this.navigationTabs.addEventListener("mouseleave", () => {
      this.isDragging = false;
      this.navigationTabs.classList.remove("dragging");
    });
  }

  updateArrows() {
    const isScrollable = this.navigationTabs.scrollWidth > this.navigationTabs.clientWidth;

    if (!isScrollable) {
      this.leftArrow.style.opacity = "0";
      this.rightArrow.style.opacity = "0";
      this.leftArrow.style.visibility = "hidden";
      this.rightArrow.style.visibility = "hidden";
      this.leftArrow.classList.add('not-visible')
      return;
    }

    this.leftArrow.style.opacity = "1";
    this.rightArrow.style.opacity = "1";
    this.leftArrow.style.visibility = "visible";
    this.rightArrow.style.visibility = "visible";

    this.leftArrow.classList.remove('not-visible')

    this.leftArrow.disabled = this.navigationTabs.scrollLeft <= 0;
    this.rightArrow.disabled =
      this.navigationTabs.scrollLeft + this.navigationTabs.clientWidth >= this.navigationTabs.scrollWidth;
  }

  observeStickyState() {
    if (!this.stickyEl) return;

    const checkSticky = () => {
      const rect = this.stickyEl.getBoundingClientRect();
    
      const computedTop = parseFloat(getComputedStyle(this.stickyEl).top);
      const isStuck = Math.round(rect.top) === Math.round(computedTop);
    
      this.stickyEl.classList.toggle("is-sticky", isStuck);
    };

    window.addEventListener("scroll", checkSticky, { passive: true });
    window.addEventListener("resize", checkSticky);
    checkSticky();
  }
}

customElements.define("product-tabs", ProductTabs);